import { MarkerStencil } from "../../redux/slices";
import { BasketballMarker, BasketballMiscType } from "./basketball/marker";
import { Point, StencilType } from "./frame-stencil";
import { HockeyMarker, HockeyMiscType } from "./hockey/marker";
import { SoccerMarker, SoccerMiscType } from "./soccer";

/** ================================
 * Base
 ================================ */
export enum MarkerType {
  PLAYER = "PLAYER",
  BALL = "BALL",
  TEXT = "TEXT",
  MISC = "MISC",
  SHADING_RECTANGLE = "SHADING_RECTANGLE",
  SHADING_OVAL = "SHADING_OVAL",
  SHADING_TRAPEZOID = "SHADING_TRAPEZOID",
}

export interface MarkerBase {
  id: string;
  stencilName?: MarkerStencil["stencilName"] | undefined;
  stencilType: StencilType.MARKER;
  label?: string;
  color?: string;
  rotate?: number;
  pos: Point;
}

export interface Movement {
  id: string;
}

/** ================================
 * Marker
 ================================ */
// Player
export interface Player extends MarkerBase {
  markerType: MarkerType.PLAYER;
  playerIdNumber: number;
  fill: boolean;
  possession: boolean;
  movements: Movement[];
}

// Ball
export enum BallMovementType {
  BALL_ACTION = "BALL_ACTION",
  POSSESSION = "POSSESSION",
}
export interface BallPossessionMovement extends Movement {
  movementType: BallMovementType.POSSESSION;
  startTime: number;
}
export interface BallActionMovement extends Movement {
  movementType: BallMovementType.BALL_ACTION;
}
export type BallMovement = BallPossessionMovement | BallActionMovement;
export interface Ball extends MarkerBase {
  markerType: MarkerType.BALL;
  associatedPlayer: string;
  movements: BallMovement[];
}

// TextBox
export interface TextBox extends MarkerBase {
  markerType: MarkerType.TEXT;
  width: number;
}

// Misc
export type MiscType = BasketballMiscType | HockeyMiscType | SoccerMiscType;
export interface Misc<TMiscType extends MiscType = MiscType> extends MarkerBase {
  markerType: MarkerType.MISC;
  miscType: TMiscType;
}

export interface RectangleShading extends MarkerBase {
  markerType: MarkerType.SHADING_RECTANGLE;
  width: number;
  height: number;
}

export interface OvalShading extends MarkerBase {
  markerType: MarkerType.SHADING_OVAL;
  rx: number;
  ry: number;
}

export interface TrapezoidShading extends MarkerBase {
  markerType: MarkerType.SHADING_TRAPEZOID;
  shadeVertices: Point[];
}

export type Marker = BasketballMarker | HockeyMarker | SoccerMarker;
